import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
export default function Select(props) {
    const { label, value, options, onChange } = props;
    const onChangeNative = useCallback((e) => {
        onChange(e.target.value);
    }, [onChange]);
    return (_jsxs("label", { className: "group flex cursor-pointer items-center gap-2", children: [_jsx("span", { className: "text-xs", children: label }), _jsx("select", { className: "cursor-pointer rounded-lg border-none bg-alveus-tan-100 px-2 py-1 text-xs text-alveus-green outline-highlight transition-[outline] group-focus-within:outline-3 group-hover:outline-3", onChange: onChangeNative, value: value, children: options.map((option) => (_jsx("option", { value: option.value, children: option.label }, option.value))) })] }));
}
